import {
  RadioGroup,
  Grid,
  FormLabel,
  FormControlLabel,
  Radio,
} from '@material-ui/core';
import Context from 'context';
import React, { useContext } from 'react';
import ImageUploader from 'react-images-upload';

const SelectPicture = () => {
  const { gender, setGender, setProfile } = useContext(Context);

  function onDrop(picture: any) {
    setGender('url');
    const objectUrl = URL.createObjectURL(picture[0]);
    setProfile(objectUrl);
  }

  return (
    <>
      <RadioGroup
        aria-label='gender'
        name='gender1'
        value={gender}
        onChange={(e) =>
          (e.target.value === 'male' ||
            e.target.value === 'female' ||
            e.target.value === 'url') &&
          setGender(e.target.value)
        }
      >
        <Grid container alignContent='center' spacing={2}>
          <Grid item style={{ alignSelf: 'center' }}>
            <FormLabel>รูปโปรไฟล์: </FormLabel>
          </Grid>
          <Grid item>
            <FormControlLabel value='male' control={<Radio />} label='ผมสั้น' />
          </Grid>
          <Grid item>
            {' '}
            <FormControlLabel
              value='female'
              control={<Radio />}
              label='ผมยาว'
            />
          </Grid>
          <Grid item>
            {' '}
            <FormControlLabel value='url' control={<Radio />} label='อัพโหลด' />
          </Grid>
        </Grid>
      </RadioGroup>
      <ImageUploader
        buttonText='อัพโหลดรูปภาพ'
        onChange={onDrop}
        imgExtension={['.jpg', '.gif', '.png']}
        maxFileSize={5242880}
        singleImage
        withLabel={false}
      />
    </>
  );
};

export default SelectPicture;
